import { IDashboardState } from "@/apps/dashboard/models/IDashboardState";

const getters = {
  getFullName: (state: IDashboardState): string | null => {
    return `${state.user.firstName} ${state.user.lastName}` ?? null;
  },
};

export default getters;
